import React from 'react';

import * as styles from './Image.styles';

interface ImageProps {
  src: string;
  alt?: string;
  isFullWidth?: boolean;
}

export const Image = ({ src, alt = '', isFullWidth }: ImageProps) => {
  return <img src={src} alt={alt} css={styles.Image} data-full-width={isFullWidth} />;
};
